// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (max-width: 423px) {
  .landload_tocken_block {
    flex-direction: column;
    padding: 10px !important;
  }
  .history_card_landload {
    height: auto;
    flex-direction: column;
    align-items: start;
    padding: 15px;
  }
  .text_agent_label {
    font-size: 15px !important;
  }
  .tocken_content p {
    font-size: 17px;
  }
}

@media only screen and (max-width: 676px) {
  .dashboard-menu {
    flex-direction: column;
    display: block !important;
    margin-bottom: 30px;
  }
  .card_single {
    width: 100%;
    max-width: none;
  }
  .dashboard-menu-title {
    flex-wrap: wrap;
  }
  .landload_button {
    width: 100%;
  }
  .btn_sec_landload {
    width: 100%;
    flex-wrap: nowrap;
  }
  .search_table_landload {
    width: 100%;
  }
  .form-control-landload {
    max-width: 100% !important;
  }
  .landload_property_details {
    flex-direction: column !important;
  }
  .landload_button_group {
    flex-direction: column;
    margin-bottom: 20px;
  }
  .btn-boots-details {
    min-width: auto;
    width: 100%;
    margin-bottom: 20px;
  }
  .img__container {
    border: none !important;
  }
  .landload_add_new_properties {
    flex-direction: column;
  }
  .landload_btn_generate {
    width: 100% !important;
  }

  .btns_sec_landload {
    flex-direction: column;
    width: -webkit-fill-available;
  }

  .btn_export_landloard {
    width: 100% !important;
    max-width: none;
  }
  .updates_order .form-control {
    width: 100%;
    min-width: auto;
  }
  .range_landloard {
    flex-direction: column;
  }
  .range_picker {
    width: 100%;
  }
  .select_dropdown_landload {
    width: 100% !important;
    min-width: auto;
  }
  .range_main_div {
    flex-direction: column;
  }
}

@media only screen and (min-width: 767px) and (max-width: 1024px) {
  .search_table_landload {
    flex-direction: row !important;
  }

  .search_landload {
    min-width: 190px !important;
  }

  .btn_responsive {
    min-width: 110px !important;
  }
  .updates_order .form-control {
    width: 100%;
    min-width: auto;
  }
}

@media only screen and (min-width: 767px) and (max-width: 992px) {
  .btn_res {
    margin-top: -10px;
  }
  .text-add-text {
    font-size: 20px;
  }
}

@media only screen and (min-width: 747px) and (max-width: 1024px) {
  .range_picker {
    width: 95px;
  }
  .select_dropdown_landload {
    width: 100px !important;
    height: 0px;
  }

  .text-tablet {
    font-size: 10px;
  }

  .drop-down-min {
    min-width: 85px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/landloadownerpenal/styles/responsive.css"],"names":[],"mappings":"AAAA;EACE;IACE,sBAAsB;IACtB,wBAAwB;EAC1B;EACA;IACE,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;IACtB,eAAe;EACjB;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;EACA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["@media only screen and (max-width: 423px) {\n  .landload_tocken_block {\n    flex-direction: column;\n    padding: 10px !important;\n  }\n  .history_card_landload {\n    height: auto;\n    flex-direction: column;\n    align-items: start;\n    padding: 15px;\n  }\n  .text_agent_label {\n    font-size: 15px !important;\n  }\n  .tocken_content p {\n    font-size: 17px;\n  }\n}\n\n@media only screen and (max-width: 676px) {\n  .dashboard-menu {\n    flex-direction: column;\n    display: block !important;\n    margin-bottom: 30px;\n  }\n  .card_single {\n    width: 100%;\n    max-width: none;\n  }\n  .dashboard-menu-title {\n    flex-wrap: wrap;\n  }\n  .landload_button {\n    width: 100%;\n  }\n  .btn_sec_landload {\n    width: 100%;\n    flex-wrap: nowrap;\n  }\n  .search_table_landload {\n    width: 100%;\n  }\n  .form-control-landload {\n    max-width: 100% !important;\n  }\n  .landload_property_details {\n    flex-direction: column !important;\n  }\n  .landload_button_group {\n    flex-direction: column;\n    margin-bottom: 20px;\n  }\n  .btn-boots-details {\n    min-width: auto;\n    width: 100%;\n    margin-bottom: 20px;\n  }\n  .img__container {\n    border: none !important;\n  }\n  .landload_add_new_properties {\n    flex-direction: column;\n  }\n  .landload_btn_generate {\n    width: 100% !important;\n  }\n\n  .btns_sec_landload {\n    flex-direction: column;\n    width: -webkit-fill-available;\n  }\n\n  .btn_export_landloard {\n    width: 100% !important;\n    max-width: none;\n  }\n  .updates_order .form-control {\n    width: 100%;\n    min-width: auto;\n  }\n  .range_landloard {\n    flex-direction: column;\n  }\n  .range_picker {\n    width: 100%;\n  }\n  .select_dropdown_landload {\n    width: 100% !important;\n    min-width: auto;\n  }\n  .range_main_div {\n    flex-direction: column;\n  }\n}\n\n@media only screen and (min-width: 767px) and (max-width: 1024px) {\n  .search_table_landload {\n    flex-direction: row !important;\n  }\n\n  .search_landload {\n    min-width: 190px !important;\n  }\n\n  .btn_responsive {\n    min-width: 110px !important;\n  }\n  .updates_order .form-control {\n    width: 100%;\n    min-width: auto;\n  }\n}\n\n@media only screen and (min-width: 767px) and (max-width: 992px) {\n  .btn_res {\n    margin-top: -10px;\n  }\n  .text-add-text {\n    font-size: 20px;\n  }\n}\n\n@media only screen and (min-width: 747px) and (max-width: 1024px) {\n  .range_picker {\n    width: 95px;\n  }\n  .select_dropdown_landload {\n    width: 100px !important;\n    height: 0px;\n  }\n\n  .text-tablet {\n    font-size: 10px;\n  }\n\n  .drop-down-min {\n    min-width: 85px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
